export const formatPhoneNumber = (phone?: string | null): string => {
  if (!phone) {
    return '';
  }
  if (phone === '') {
    return '';
  }
  if (phone.length === 10) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }
  return `+${phone.slice(0, 1)}(${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7)}`;
};
